import http from 'plugins/axios';

export default {

  configList(data) {
    return http.get({
      url: '/admin/audit/config/list',
      data
    });
  },

  configInsert(data) {
    return http.post({
      url: '/admin/audit/config/insert',
      data,
      dataType: 'form'
    });
  },

  configUpdate(data) {
    return http.post({
      url: '/admin/audit/config/update',
      data,
      dataType: 'form'
    });
  },

  configRemove(data) {
    return http.post({
      url: '/admin/audit/config/remove',
      data,
      dataType: 'form'
    });
  },

  queryEnterAccountList(data) {
    return http.get({
      url: '/admin/enter/account/list',
      data
    });
  },

  checkEnterAccount(data) {
    return http.post({
      url: '/admin/enter/account/check',
      data,
      dataType: 'form'
    });
  },

  refuseEnterAccount(data) {
    return http.post({
      url: '/admin/enter/account/refuse',
      data,
      dataType: 'form'
    });
  },
  getHotCoinList(data) {
    return http.get({
      url: '/admin/hot/coin/list',
      data
    });
  },
  hotCoinaddOrUpdate(data) {
    return http.post({
      url: '/admin/hot/coin/addOrUpdate',
      data,
      dataType: 'form'
    });
  }
};
